module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEHSURBVHgB7ddBDoIwEAXQsQvOUVlxDU/ONVhhj0FYEJmFCWnQMO0fY5P/Nhhj4Y8tdBAhIiIiKnaz/Ljv+6ceu657TNOUBCjuQgijfp7n+X51XBC7uK7rOAxDFJBD+ChGpgK2bXvshyTAIrLwSWfXMt60hD5dsHQ5Ic5lLgB1YdQfUVRAbQDkLBYXUBoEGV5VFWANhA6vqguQi8E8witIAepbQK/wClaAOgu6LIt4hVfQAlRexPtrcQiv4AWok9bAJbwq6YX+SvNLCDoDZzexRwN4xMeoanoja7qVaLqZa7qdbvqFpulXSo+bsPacpo3M4zGYdvlmZxlfshPDW4KsCCIiIqJfeQE5TBVIDsK0XAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.png
// module id = JA1j
// module chunks = 0